import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useOverviewRoute} from './use-overview-route'
import {pullRequestsOverviewIndexRoute, pullRequestsOverviewRoute} from '../../../routes/overview-route'

export function useOverviewRouteData() {
  const overviewRoute = useOverviewRoute()
  return useRouteQuery(overviewRoute, 'mainQuery')
}

export function useOverviewRouteQueryKey() {
  const overviewQueryKey = useRouteQueryKey(pullRequestsOverviewRoute, 'mainQuery')
  const indexQueryKey = useRouteQueryKey(pullRequestsOverviewIndexRoute, 'mainQuery')
  return overviewQueryKey ?? indexQueryKey
}
